import { useEffect, useRef } from 'react';
import { ActivityIndicator, View } from 'react-native';

import { useAppLink } from '@/components/providers/AppLinkProvider';
import { useRawSearchParam } from '@/hooks/useRawSearchParam';

const logDeepLink = (...args: unknown[]) => {
  if (__DEV__) {
    console.log('[DeepLink]', ...args);
  }
};

export default function DeepLinkRoute() {
  const { isReady, openAppLink } = useAppLink();
  const handledUrlRef = useRef<string | undefined>(undefined);
  const rawUrl = useRawSearchParam('url');

  useEffect(() => {
    if (!isReady) return;

    const handleDeepLink = async () => {
      if (rawUrl && handledUrlRef.current === rawUrl) {
        logDeepLink('URL already handled, skipping', rawUrl);
        return;
      }

      handledUrlRef.current = rawUrl;

      if (!rawUrl) {
        logDeepLink('missing URL or unrecognized app link, replacing with /');
        await openAppLink('', {
          source: 'external',
          navigationAction: 'replace',
        });
        return;
      }

      await openAppLink(rawUrl, {
        source: 'external',
        navigationAction: 'replace',
      });
    };

    handleDeepLink();
  }, [isReady, openAppLink, rawUrl]);

  return (
    <View className="flex-1 items-center justify-center">
      <ActivityIndicator />
    </View>
  );
}
